import { render } from "./Product2023.vue?vue&type=template&id=52ad117a&scoped=true"
import script from "./Product2023.vue?vue&type=script&lang=js"
export * from "./Product2023.vue?vue&type=script&lang=js"

import "./Product2023.vue?vue&type=style&index=0&id=52ad117a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ad117a"]])

export default __exports__